import { useAppServices } from "hook/services";
import React, { useEffect, useState } from "react";

function ThemeTypeModel({ open, onClose, Update, agency }) {
  const Service = useAppServices();
  const [themes, setThemes] = useState([]);
  const [themeType, setThemeType] = useState("");
  const [processing, setProcessing] = useState(false);

  const GetThemes = async () => {
    const { response } = await Service.themes.get({
      query: "theme_type=supperadmin",
    });
    if (response?.success) {
      setThemes(response?.data);
    }
  };
  useEffect(() => {
    GetThemes();
  }, []);

  const handleThemeSave = async () => {
    setProcessing(true);
    try {
      const payload = {
        agency_id: agency?._id,
        theme_id: themeType,
      };
      const { response } = await Service.themes.selectTheme({payload});
      if (response?.success) {
        Update(response.data);
        onClose();
      }
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setProcessing(false);
    }
  };

  return (
    <>
      {open && (
        <>
          <style>
            {`
      .theme-overlay {
        position: fixed;
        inset: 0;
        z-index: 50;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(0, 0, 0, 0.5);
      }

      .theme-modal {
        width: 100%;
        max-width: 420px;
        background: #ffffff;
        padding: 24px;
        border-radius: 12px;
        box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
      }

      .theme-title {
        margin-bottom: 16px;
        font-size: 20px;
        font-weight: 600;
      }

      .theme-list {
        display: flex;
        flex-direction: column;
        gap: 12px;
      }

      .theme-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 12px;
        border-radius: 8px;
        border: 1px solid #e5e7eb;
        cursor: pointer;
        transition: all 0.2s ease;
      }

      .theme-item:hover {
        background: #f9fafb;
      }

      .theme-item.active {
        border-color: #2563eb;
        background: #eff6ff;
      }

      .theme-error {
        margin-top: 10px;
        font-size: 13px;
        color: #dc2626;
      }

      .theme-actions {
        margin-top: 24px;
        display: flex;
        justify-content: flex-end;
      }

      .continue-btn {
        padding: 10px 16px;
        border-radius: 8px;
        font-size: 14px;
        color: #ffffff;
        border: none;
        cursor: pointer;
        transition: background 0.2s ease;
      }

      .continue-btn.disabled {
        background: #9ca3af;
        cursor: not-allowed;
      }

      .continue-btn.active {
        background: #2563eb;
      }

      .continue-btn.active:hover {
        background: #1d4ed8;
      }
    `}
          </style>

          <div className="theme-overlay">
            <div className="theme-modal">
              <h2 className="theme-title">Select Theme</h2>

              {/* Theme List */}
              <div className="theme-list">
                {themes.map((theme) => (
                  <label
                    key={theme._id}
                    className={`theme-item ${themeType === theme._id ? "active" : ""}`}
                  >
                    <span>{theme.name}</span>
                    <input
                      type="radio"
                      name="theme"
                      value={theme._id}
                      checked={themeType === theme._id}
                      onChange={() => setThemeType(theme._id)}
                    />
                  </label>
                ))}
              </div>

              {/* Validation */}
              {!themeType && <p className="theme-error">Please select a theme to continue.</p>}

              {/* Actions */}
              <div className="theme-actions">
                <button
                  disabled={!themeType || processing}
                  onClick={handleThemeSave}
                  className={`continue-btn ${!themeType || processing ? "disabled" : "active"}`}
                >
                  Continue {processing && "..."}
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default ThemeTypeModel;
